import tippy, { Instance, Props } from 'tippy.js';

import { ICellRenderer } from '@ag-grid-enterprise/all-modules';

import '../../css/productCellRenderer.scss';

import ProductService from '@services/Product/ProductService';

class ProductCellRenderer implements ICellRenderer {
	private eGui: HTMLElement;
	private value: string;

	private instanceTooltip: Instance<Props> | null = null;

	private productService: ProductService;

	constructor() {
		this.eGui = document.createElement('div');
		this.eGui.classList.add('productCellRenderer', 'no-image');
		this.eGui.innerHTML = `
			<img class="image"/>
			<div class="text"></div>
		`;

		this.productService = new ProductService();
		this.value = '';
	}

	public init(params: any) {
		this.value = params.value;

		if (this.value) {
			const N_image = this.eGui.querySelector<HTMLImageElement>('.image')!;
			const N_text = this.eGui.querySelector('.text')!;

			this.instanceTooltip?.destroy();

			N_image.src = `/function/products/image?id=${this.value}`;

			N_image.addEventListener('load', () => {
				this.eGui.classList.remove('no-image');

				this.instanceTooltip = tippy(N_image, {
					trigger: 'mouseenter',
					placement: 'bottom-start',
					theme: 'light',
					content: `<ap-product-image-previewer src="/function/products/image?id=${this.value}"></ap-product-image-previewer>`,
					allowHTML: true
				});
			});

			this.productService.getById(this.value).then((data) => {
				N_text.innerHTML = data[this.productService.referenceKey];
			});
		}
	}

	public getGui() {
		return this.eGui;
	}

	public refresh() {
		return false;
	}
}

export default ProductCellRenderer;
